import type { ProviderConfig } from "./types"

export const slackConfig: ProviderConfig = {
  sections: [
    {
      titleKey: "integrations_slack_general",
      titleFallback: "General",
      fields: [
        {
          kind: "text",
          key: "default_channel",
          labelKey: "integrations_slack_default_channel",
          labelFallback: "Default channel",
          placeholder: "#travel-team",
        },
      ],
    },
    {
      titleKey: "integrations_slack_notifications",
      titleFallback: "Notifications",
      fields: [
        {
          kind: "switch",
          key: "notify_on_booking",
          labelKey: "integrations_slack_notify_booking",
          labelFallback: "Notify on new bookings",
          descriptionKey: "integrations_slack_notify_booking_desc",
          descriptionFallback: "Send a message when a trip is booked",
        },
        {
          kind: "switch",
          key: "notify_on_approval",
          labelKey: "integrations_slack_notify_approval",
          labelFallback: "Notify on approval requests",
          descriptionKey: "integrations_slack_notify_approval_desc",
          descriptionFallback: "Send a message when a trip needs approval",
        },
      ],
    },
  ],
}
